function cityState (address) {
  if (!address) return ''
  if (!address.city && address.state) return address.state
  if (!address.state && address.city) return address.city
  return address.city + ', ' + address.state
}

export default cityState
